<template>
    <v-container class="fill-height d-flex" style="align-items: center; justify-content: center;">
    <!-- DESKTOP -->
    <v-container fluid class="d-none d-lg-block py-16" style="padding-bottom: 200px !important;">
        <v-card class="elevation-0" light>
            <v-row align="center">
                <v-col cols="12" class="text-h4 text-center">
                    {{ $t('contacts.contact') }}
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" md="8" class="text-center">
                    <validation-observer ref="form" v-slot="{ invalid }">
                        <v-form @submit.prevent="submit" class="mb-16 font-weight-light text-caption">
                            <fieldset>
                                <v-row class="mt-4">
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Nome" name="Nome"
                                            rules="required">
                                            <v-text-field v-model="fields.name" dense
                                                :label="$t('contacts.name') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Apelido" name="Apelido"
                                            rules="required">
                                            <v-text-field v-model="fields.last_name" dense
                                                :label="$t('contacts.last_name') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Nome empresa" name="Nome empresa"
                                            rules="required">
                                            <v-text-field v-model="fields.company" dense
                                                :label="$t('contacts.company_name') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Departamento" name="Departamento"
                                            rules="|">
                                            <v-text-field v-model="fields.department" dense
                                                :label="$t('contacts.department')" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Email" name="Email"
                                            rules="required|is_email_valid">
                                            <v-text-field v-model="fields.email" dense
                                                :label="$t('contacts.email') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Telefone" name="Telefone"
                                            rules="|">
                                            <v-text-field v-model="fields.phone" dense :label="$t('contacts.phone')"
                                                clearable :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" md="12" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Mensagem" name="Mensagem"
                                            rules="required|string_size_15">
                                            <v-textarea v-model="fields.description" dense
                                                :label="$t('contacts.message') + ' *'" clearable
                                                :error-messages="errors"></v-textarea>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" class="my-0 py-0">
                                        <v-radio-group v-model="fields.policy">
                                            <v-radio color="black">
                                                <template v-slot:label>
                                                    <div>{{ $t('contacts.privacy_ok') }}</div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" justify="center" align="center">
                                        <div v-if="recaptchaReady" id="recaptcha-container"></div>
                                    </v-col>
                                    <v-col cols="12" class="text-center">
                                        <v-btn @click="sendContact" small :disabled="invalid" class="black" rounded
                                            outlined dark>{{ $t('contacts.send_message') }}</v-btn>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-form>
                    </validation-observer>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <!-- DESKTOP -->
    <!-- MOBILE -->
    <v-container fluid class="d-lg-none mt-12">
        <v-card class="elevation-0" light>
            <v-row align="center">
                <v-col cols="12" class="text-center font-weight-bold text-uppercase pb-0" style="font-size: 20px;">
                    {{ $t('contacts.contact') }}
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" md="8" class="text-center">
                    <validation-observer ref="form" v-slot="{ invalid }">
                        <v-form @submit.prevent="submit" class="mb-16 font-weight-light text-caption contact-form">
                            <fieldset>
                                <v-row class="mt-4">
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Nome" name="Nome"
                                            rules="required">
                                            <v-text-field v-model="fields.name" dense
                                                :label="$t('contacts.name') + ' *'" clearable
                                                :error-messages="errors" style="font-size: 12px;"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Apelido" name="Apelido"
                                            rules="required">
                                            <v-text-field v-model="fields.last_name" dense
                                                :label="$t('contacts.last_name') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Nome empresa" name="Nome empresa"
                                            rules="required">
                                            <v-text-field v-model="fields.company" dense
                                                :label="$t('contacts.company_name') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Departamento" name="Departamento"
                                            rules="|">
                                            <v-text-field v-model="fields.department" dense
                                                :label="$t('contacts.department')" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Email" name="Email"
                                            rules="required">
                                            <v-text-field v-model="fields.email" dense
                                                :label="$t('contacts.email') + ' *'" clearable
                                                :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="6" md="6" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Telefone" name="Telefone"
                                            rules="|">
                                            <v-text-field v-model="fields.phone" dense :label="$t('contacts.phone')"
                                                clearable :error-messages="errors"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" md="12" class="my-0 py-0">
                                        <validation-provider v-slot="{ errors }" vid="Mensagem" name="Mensagem"
                                            rules="required|string_size_15">
                                            <v-textarea v-model="fields.description" dense auto-grow rows="1"
                                                :label="$t('contacts.message') + ' *'" clearable
                                                :error-messages="errors"></v-textarea>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="12" class="my-0 py-0">
                                        <v-radio-group v-model="fields.policy" class="mt-0">
                                            <v-radio color="black">
                                                <template v-slot:label>
                                                    <div style="font-size: 12px;">{{ $t('contacts.privacy_ok') }}</div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" justify="center" align="center">
                                        <div v-if="recaptchaReady" id="recaptcha-container"></div>
                                    </v-col>
                                    <v-col cols="12" class="text-center">
                                        <v-btn @click="sendContact" small :disabled="invalid" class="black" rounded
                                            outlined dark>{{ $t('contacts.send_message') }}</v-btn>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-form>
                    </validation-observer>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <!-- MOBILE -->
    </v-container>
</template>
<script>
/* global grecaptcha */

export default {
  name: "Contact",
  data() {
    return {
      recaptchaRendered: false,
      recaptchaReady: false,
      widgetId: null, // <- ID do reCAPTCHA renderizado

      fields: {
        name: null,
        last_name: null,
        department: null,
        company: null,
        email: null,
        phone: null,
        description: null,
        policy: false,
        // Se tiveres estes campos, serão enviados; senão, ficam vazios:
        country: null,
        size: null,
      }
    };
  },

  mounted() {
    // Espera o script do reCAPTCHA ficar pronto
    const check = setInterval(() => {
      if (window.grecaptcha && grecaptcha.ready) {
        clearInterval(check);
        this.recaptchaReady = true;
        this.$nextTick(() => this.renderRecaptcha());
      }
    }, 300);
  },

  methods: {
    renderRecaptcha() {
      grecaptcha.ready(() => {
        const el = document.getElementById('recaptcha-container');
        if (!el) {
          // A div ainda não está no DOM (por causa do v-if) — tenta outra vez
          setTimeout(this.renderRecaptcha, 200);
          return;
        }
        if (!this.recaptchaRendered) {
          // Renderiza e guarda o widgetId para podermos obter/resetar o token
          this.widgetId = grecaptcha.render(el, {
            sitekey: process.env.VUE_APP_GOOGLE_CAPTCHA_KEY
          });
          this.recaptchaRendered = true;
        }
      });
    },

    async sendContact () {
    const endpoint = process.env.VUE_APP_SEND_EMAIL;
    if (!endpoint) {
        console.error('VUE_APP_SEND_EMAIL não está definido no .env do front.');
        return;
    }

    // 1) Token do reCAPTCHA v2 (checkbox)
    let token = '';
    try {
        token = grecaptcha.getResponse(this.widgetId) || '';
    } catch (e) {
        console.error('grecaptcha.getResponse falhou:', e);
    }
    if (!token) {
        alert('Por favor valida o reCAPTCHA.');
        return;
    }

    // 2) Payload com TODOS os campos + mapeamento para o backend
    const payload = {
        // --- TODOS os campos do form ---
        name:        this.fields.name,
        last_name:   this.fields.last_name,
        department:  this.fields.department,
        company:     this.fields.company,
        email:       this.fields.email,
        phone:       this.fields.phone,
        description: this.fields.description,
        policy:      this.fields.policy,
        country:     this.fields.country ?? '',
        size:        this.fields.size ?? '',

        // --- O que o backend espera explicitamente ---
        message: this.fields.description,         // corpo da mensagem
        numero:  this.fields.phone || '',         // telefone/numero
        'g-recaptcha-response': token,            // token reCAPTCHA v2
        website_hp: '',                           // honeypot vazio
        started_at: Math.floor(Date.now() / 1000) // timestamp simples
    };

    // 3) Envio
    try {
        const url = process.env.VUE_APP_SEND_EMAIL // Vite: import.meta.env.VITE_SEND_EMAIL
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        const json = await res.json()
        if (!res.ok || json?.success !== true) {
          throw new Error(json?.message || 'Falha ao enviar.')
        }

        // 4) Reset do reCAPTCHA (permite novo envio)
        try {
            if (this.widgetId != null) grecaptcha.reset(this.widgetId);
        } catch (e) {console.log(e)}

        // 5) Navegar para sucesso
            this.$router.push('/' + this.$i18n.locale + '/thankyouform');

            // (Opcional) devolver payload para debug
            return payload;
        } catch (err) {
            if(err == null) return
            if(err == undefined) return
            if(err == '') return
            console.error('Falha ao enviar contacto:', err?.response?.data || err?.message || err);
            this.$router.push('/' + this.$i18n.locale + '/thankyouform');
            return

        }
        }
    }
    };
</script>

<style>
@media only screen and (max-width: 1263px) {
    .contact-form .v-label{
        font-size: 13px;
    }
}
</style>